export default __webpack_public_path__ + "static/media/copy.18fe083f.svg";